<div class="home-container">
    <app-header />
    <div class="home-body">
      <app-sidebar (viewSelected)="switchView($event)" />
  
      <main class="home-content">
        @switch (currentView()) {
          @case ('index') { <app-index /> }
          @case ('documents') { <app-documents [viewType]="currentView()" /> }
          @case ('to-process') { <app-documents [viewType]="currentView()" /> }
          @case ('processed') { <app-documents [viewType]="currentView()" /> }
          @case ('error') { <app-documents [viewType]="currentView()" /> }
          @case ('web-sites') { <app-web-sites /> }
        }
      </main>
    </div>
  </div>